export const labels = {
  es: {
    firstName: "Nombre/s",
    lastName: "Apellido/s",
    countryOfBirth: "País de residencia",
    referral: "Nombre o mail de quien te refirió",
  },

  en: {
    firstName: "First name/s",
    lastName: "Last name/s",
    countryOfBirth: "Country of residence",
    referral: "Referrer's name or email",
  },
};

export const title = {
  es: "Abrir una cuenta",
  en: "Account opening",
};

export const placeholders = {
  es: {
    countryOfBirth: "Seleccioná una opción",
  },

  en: {
    countryOfBirth: "Choose an option",
  },
};
